import * as React from 'react';
import {observer} from "mobx-react"
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import '../index.css';
import '../../images/Verkauf_1.jpg';
import '../../images/Verkauf_2.jpg';
import '../../images/Verkauf_3.jpg';
import '../../images/Verkauf_4.jpg';
import '../../images/deutz.jpg';
import '../../images/carraro.jpg';
import '../../images/rapid.jpg';
import '../../images/claas.jpg';
import '../../images/kuhn.jpg';
import '../../images/stepa.jpg';
import '../../images/manitou.jpg';
import '../../images/rosensteiner.jpg';
import '../../images/hauer.jpg';
import '../../images/jcb.jpg';
import '../../images/fuhrmann.jpg';
import '../../images/siloking.jpg';
import '../../images/muething.jpg';
import '../../images/weiss.jpg';
import '../../images/mammut.jpg';
import '../../images/westa.jpg';
import '../../images/rigitrac.jpg';
import '../../images/knuesel.jpg';
import '../../images/sip.jpg';
import '../../images/agrar.jpg';
import '../../images/krpan.png';
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import ListSubheader from "@material-ui/core/ListSubheader";



@observer
export default class MaschinenVerkauf extends React.Component {



    render()
    {

        return (
            <div>
                <div className="header_Verkauf">
                    <div className="header_openHours_text">Verkauf</div>
                    <div className="header_openHours_body">Maschinenverkauf – Ausstellungsgelände – Ausstellungshalle</div>
                </div>
                <div className="textVerkauf">
                    Wir führen Marken führender Landtechnikhersteller und präsentieren
                    Ihnen Neu- und Gebrauchte Landtechnik am großzügigen Betriebsgelände
                    mit überdachter Freifläche und Ausstellungshalle.

                </div>
                <div className="wrapperVerkauf">
                    <div className="root">
                        <GridList cellHeight={150}  spacing={30} className="gridListNeumaschinen" cols={4}>
                                <GridListTile key={"1"}>
                                    <div className="container container_no_padding">
                                        <img src="./images/Verkauf_1.jpg"
                                             alt="abc" className="image"/>
                                    </div>
                                </GridListTile>
                            <GridListTile key={"2"}>
                                <div className="container container_no_padding">
                                    <img src="./images/Verkauf_2.jpg"
                                         alt="abc" className="image"/>
                                </div>
                            </GridListTile>
                            <GridListTile key={"3"}>
                                <div className="container container_no_padding">
                                    <img src="./images/Verkauf_3.jpg"
                                         alt="abc" className="image"/>
                                </div>
                            </GridListTile>
                            <GridListTile key={"4"}>
                                <div className="container container_no_padding">
                                    <img src="./images/Verkauf_4.jpg"
                                         alt="abc" className="image"/>
                                </div>
                            </GridListTile>
                        </GridList>
                    </div>
                </div>
                <div className="header_Verkauf_Brands">
                    <div className="header_openHours_text">Produktübersicht</div>
                    <div className="header_openHours_body">Hier finden Sie unsere Marken</div>
                </div>

                    <div className="root">
                        <GridList cellHeight={350}  spacing={30} className="gridListBrands" cols={3}>
                            <GridListTile key={"1"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Deutz Fahr
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Traktoren
                                        </div>
                                        <div>
                                            <a  href={"https://www.deutz-fahr.at/traktoren/"}>
                                                <img src="./images/deutz.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"2"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Antonio Carraro
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Mähtrak/Unversialtraktoren
                                        </div>
                                        <div>
                                            <a  href={"https://www.antoniocarraro.it/de/katalog"}>
                                                <img src="./images/carraro.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"3"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Rapid
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Einachsmaschinen/Anbaugeräte
                                        </div>
                                        <div>
                                            <a  href={"https://www.rapid.ch/de/shop/katalog~c57"}>
                                                <img src="./images/rapid.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>

                            <GridListTile key={"4"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Claas
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Traktoren/Futterernte
                                        </div>
                                        <div>
                                            <a  href={"https://www.claas.at/produkte"}>
                                                <img src="./images/claas.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"5"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Kuhn
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Futterernte/Bodenbearbeitung
                                        </div>
                                        <div>
                                            <a  href={"https://www.kuhncenter.at/internet/webat.nsf/0/20E8C4AB26586B17C12577C00032A5FD?OpenDocument&p=2.8"}>
                                                <img src="./images/kuhn.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"6"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Stepa
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Heukrananlagen/Mobil-/Forstkran
                                        </div>
                                        <div>
                                            <a href={"https://www.stepakran.com/de/landwirtschaft/haengedrehkrane/"}>
                                                <img src="./images/stepa.jpg" className="image"/>
                                            </a>
                                            </div>
                                    </div>
                                </div>
                            </GridListTile>

                            <GridListTile key={"7"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Manitou
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Hof-/Telelader
                                        </div>
                                        <div>
                                            <a href={"https://www.manitou.com/de/s/articulated_loaders"}>
                                                <img src="./images/manitou.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"8"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Rosensteiner
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Kippmulden/Klauenpflege
                                        </div>
                                        <div>
                                            <a href={"https://www.rosensteiner.at"}>
                                                <img src="./images/rosensteiner.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"9"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Hauer
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Frontlader/Schneepflüge
                                        </div>
                                        <div>
                                            <a href={"https://www.hfl.co.at"}>
                                                <img src="./images/hauer.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>

                            <GridListTile key={"10"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            JCB
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Fastrac/Telelader
                                        </div>
                                        <div>
                                            <a href={"https://www.jcb-agri.at"}>
                                                <img src="./images/jcb.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"11"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Fuhrmann
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Kipper
                                        </div>
                                        <div>
                                            <a href={"https://www.fuhrmann.at"}>
                                                <img src="./images/fuhrmann.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"12"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Siloking
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Mischwagen 3 – 40 m3
                                        </div>
                                        <div>
                                            <a href={"https://www.siloking.com/de/siloking-produktuebersicht"}>
                                                <img src="./images/siloking.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>

                            <GridListTile key={"13"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            MÜTHING
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Mulchsysteme
                                        </div>
                                        <div>
                                            <a href={"https://www.müthing-mulcher.de"}>
                                                <img src="./images/muething.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"14"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            WEISS MAWEK
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Heulüfter / Entfeuchter
                                        </div>
                                        <div>
                                            <a href={"https://www.weiss-söll.at"}>
                                                <img src="./images/weiss.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"15"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            MAMMUT
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Maschinen
                                        </div>
                                        <div>
                                            <a href={"https://www.mammut.at"}>
                                                <img src="./images/mammut.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>

                            <GridListTile key={"16"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Westa
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Schneefräsen
                                        </div>
                                        <div>
                                            <a href={"https://www.westa.de"}>
                                                <img src="./images/westa.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"17"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Rigitrac
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Traktoren
                                        </div>
                                        <div>
                                            <a href={"https://www.rigitrac.ch/produkte-1/"}>
                                                <img src="./images/rigitrac.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"18"}>
                            <div className="container container_no_padding">
                                <div className="imageWrapperVerkauf">
                                    <div className="textVerkaufGridHeader">
                                        Knüsel
                                    </div>
                                    <div className="textVerkaufGridItems">
                                        Mähwerk/Bandheuer
                                    </div>
                                    <div>
                                        <a href={"https://www.knuesel-sepp.ch/produkte-1/"}>
                                            <img src="./images/knuesel.jpg" className="image"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </GridListTile>

                            <GridListTile key={"19"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            SIP
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Mähwerk für Mähtrac
                                        </div>
                                        <div>
                                            <a href={"https://www.sip.si/produkte"}>
                                                <img src="./images/sip.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"20"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Agrar
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Ladewagen
                                        </div>
                                        <div>
                                            <a href={"https://www.agrar-landtechnik.ch/ladewagen.html"}>
                                                <img src="./images/agrar.jpg" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>
                            <GridListTile key={"21"}>
                                <div className="container container_no_padding">
                                    <div className="imageWrapperVerkauf">
                                        <div className="textVerkaufGridHeader">
                                            Krpan
                                        </div>
                                        <div className="textVerkaufGridItems">
                                            Seilwinden/Holzspalter/Kippschaufel
                                        </div>
                                        <div>
                                            <a href={"https://www.vitli-krpan.com/de/produkte"}>
                                                <img src="./images/krpan.png" className="image"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </GridListTile>

                        </GridList>
                    </div>
                </div>


        );

    }


}


